export function cn(...values) {
    const out = [];
    for (const value of values) {
        if (!value && value !== 0)
            continue;
        if (Array.isArray(value)) {
            const nested = cn(...value);
            if (nested)
                out.push(nested);
        }
        else {
            out.push(String(value));
        }
    }
    return out.join(' ');
}
